import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '@/api/axios';
import { API } from '@/api/endpoints';
import { STALE_TIME } from '@/api/staleTimes';
import {
  appVersionCheckReportSchema,
  appVersionListSchema,
  type AppVersion,
  type AppVersionCheckParams,
  type AppVersionCheckReport,
} from '../types/appVersionCheck.types';

export const appVersionCheckQueryKeys = {
  all: () => ['app-version-check'] as const,
  report: (params: AppVersionCheckParams) =>
    [...appVersionCheckQueryKeys.all(), 'report', params] as const,
  versions: () => ['app-versions'] as const,
};

export const appVersionCheckQueryOptions = (params: AppVersionCheckParams) =>
  queryOptions({
    queryKey: appVersionCheckQueryKeys.report(params),
    queryFn: async (): Promise<AppVersionCheckReport> => {
      const res = await apiClient.get(API.appVersionCheck.report, { params });
      return appVersionCheckReportSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });

export const appVersionListQueryOptions = () =>
  queryOptions({
    queryKey: appVersionCheckQueryKeys.versions(),
    queryFn: async (): Promise<AppVersion[]> => {
      const res = await apiClient.get(API.appVersion.list);
      return appVersionListSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });
